export const formatType = (type) =>
  type
    ? type.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (c) => c.toUpperCase())
    : "-";

// Builds { label, value: "YYYY-MM" } options only for months that actually have entries,
// most recent first.
export const getMonthOptionsFromEntries = (entries) => {
  const seen = new Map();
  entries.forEach((e) => {
    const d = new Date(e.createdAt);
    if (Number.isNaN(d.getTime())) return;
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    if (!seen.has(value)) {
      seen.set(value, d.toLocaleString("default", { month: "long", year: "numeric" }));
    }
  });
  return Array.from(seen, ([value, label]) => ({ value, label })).sort((a, b) =>
    b.value.localeCompare(a.value)
  );
};
